<ng-container *ngIf="!isReadOnly">
	<button
		*ngIf="hasUnsavedChanges"
		tlkButton
		variant="secondary"
		size="m"
		class="rx-intuitive-bridge-footer__discard-btn"
		(click)="onRevertChanges()"
	>
		{{ 'ToothEditor.DiscardChanges' | translate }}
	</button>
	<button
		tlkButton
		variant="primary"
		size="m"
		class="rx-intuitive-bridge-footer__save-btn"
		(click)="onSaveBridge()"
	>
		{{ 'ToothEditor.SaveBridge' | translate }}
	</button>
</ng-container>
<button
	*ngIf="isReadOnly"
	tlkButton
	variant="secondary"
	size="m"
	class="rx-intuitive-bridge-footer__close-btn"
	(click)="onClose()"
>
	{{ 'ToothEditor.Close' | translate }}
</button>
